/**
 * Depuración: lecturas de saldos (multicall / hooks) frente a lo que pinta la UI.
 *
 * Activar **sin rebuild**:
 *   localStorage.setItem('DEBUG_READ_BALANCES_UI', '1'); location.reload()
 *   (también `'true'`; clave legacy: `DEBUG_UI_BALANCES`).
 *
 * Activar **por build**:
 *   VITE_DEBUG_READ_BALANCES_UI=true
 *
 * Compatibilidad temporal: `VITE_DEBUG_UI_BALANCES`, clave `DEBUG_UI_BALANCES`.
 *
 * Guía canónica: `docs/500-guias/logs-debug-y-flags.md`.
 */

import { localStorageDebugOn, viteEnvDebugTrue } from './debugActivation'

const LS_PRIMARY = 'DEBUG_READ_BALANCES_UI'
const LS_LEGACY = 'DEBUG_UI_BALANCES'

const LOG_PREFIX = '[READ_BALANCES_UI]'

export function isReadBalancesUiDebugEnabled(): boolean {
  if (viteEnvDebugTrue(import.meta.env.VITE_DEBUG_READ_BALANCES_UI)) return true
  if (viteEnvDebugTrue(import.meta.env.VITE_DEBUG_UI_BALANCES)) return true
  if (typeof window === 'undefined') return false
  try {
    if (localStorageDebugOn(window.localStorage?.getItem(LS_PRIMARY))) return true
    if (localStorageDebugOn(window.localStorage?.getItem(LS_LEGACY))) return true
  } catch {
    return false
  }
  return false
}

export function readBalancesUiDebug(tag: string, payload: Record<string, unknown>): void {
  if (!isReadBalancesUiDebugEnabled()) return
  // eslint-disable-next-line no-console
  console.log(`${LOG_PREFIX} ${tag}`, payload)
}
